.cancelBtn {
  margin: 9px 0 10px 0;
  border-radius: var(--radius-md, 4px);
  height: 40px;
  box-sizing: border-box;
  border: 1px solid var(--drp-cancel-border, #D0D5DD);
  background: var(--drp-cancel-bg, #FFF);
  padding: 6px 20px !important;
  cursor: pointer;

  /* Shadows/shadow-xs */

  color: var(--drp-cancel-text, #344054);
  /* Text sm/Semibold */
  font-family: Inter, sans-serif;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 20px; /* 142.857% */

}

.applyBtn {
  margin: 9px 16px 10px 12px;
  border-radius: var(--radius-md, 4px);
  border: 1px solid var(--drp-apply-border, #BE2987);
  padding: 6px 20px !important;
  background: var(--drp-apply-bg, #BE2987);
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;

  color: var(--drp-apply-text, #FFF);
/* Text sm/Semibold */
  /* Text sm/Semibold */
  font-family: Inter, sans-serif;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 20px; /* 142.857% */
}

.applyBtn:disabled,
.applyBtn[disabled],
.applyBtn.disabled {
  background: var(--drp-apply-bg-disabled, #E9C5DC) !important;
  border-color: var(--drp-apply-border-disabled, #E9C5DC) !important;
  color: var(--drp-apply-text-disabled, #FFF) !important;
  cursor: not-allowed !important;
}

.applyBtn:disabled:hover,
.applyBtn[disabled]:hover,
.applyBtn.disabled:hover {
  background: var(--drp-apply-bg-disabled, #E9C5DC) !important;
  border-color: var(--drp-apply-border-disabled, #E9C5DC) !important;
  color: var(--drp-apply-text-disabled, #FFF) !important;
}
